module.exports = __webpack_public_path__ + "img/Ecover.a216c130.jpg";